import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { VideoModal } from './videoModal.component';
import { selectActiveVideo, selectActiveVideoHost } from '../../../reducers/video/video.selectors';
import { VideoActions } from '../../../reducers/video/video.redux';


const mapStateToProps = createStructuredSelector({
  videoId: selectActiveVideo,
  videoHost: selectActiveVideoHost,
});

export const mapDispatchToProps = (dispatch) => bindActionCreators({
  closeVideo: VideoActions.closeVideo,
}, dispatch);

export default connect(mapStateToProps, mapDispatchToProps)(VideoModal);
